<ng-container *ngIf="readOnly; else editing">
  <div class="read-only-info">
    <div>
      <a [href]="websiteScrapeConfig?.url" target="_blank">
        {{ websiteScrapeConfig?.url }}
        <mat-icon inline="true" class="open-in-new" iconPositionEnd>open_in_new</mat-icon>
      </a>
    </div>
    <div>
      {{ getCrawlModeTranslationKey(websiteScrapeConfig?.crawlMode) | translate }}
    </div>
  </div>
  <ng-container *ngTemplateOutlet="scrapedPages"></ng-container>
</ng-container>
<ng-template #editing>
  <ng-container [formGroup]="form">
    <glxy-form-field [required]="true">
      <glxy-label>{{ 'EDIT_KNOWLEDGE.NAME' | translate }}</glxy-label>
      <input matInput formControlName="name" />
      <glxy-error *ngIf="form.get('name')?.hasError('required') && form.get('name')?.dirty">
        {{ 'EDIT_KNOWLEDGE.REQUIRED_FIELD' | translate }}
      </glxy-error>
    </glxy-form-field>
    <glxy-form-field [required]="true">
      <glxy-label>{{ 'EDIT_KNOWLEDGE.WEBSITE_SCRAPE_CONFIG.URL' | translate }}</glxy-label>
      <input matInput type="text" formControlName="url" [required]="true" />
      <glxy-error *ngIf="form.get('url')?.errors && form.get('url')?.dirty">
        {{ 'EDIT_KNOWLEDGE.WEBSITE_SCRAPE_CONFIG.INVALID_URL' | translate }}
      </glxy-error>
    </glxy-form-field>
    <glxy-form-field [required]="true">
      <glxy-label>{{ 'EDIT_KNOWLEDGE.WEBSITE_SCRAPE_CONFIG.CRAWL_MODE' | translate }}</glxy-label>
      <mat-select formControlName="crawlMode">
        <mat-option [value]="crawlModes.WEBSITE_SCRAPE_CONFIG_CRAWL_MODE_SINGLE">
          {{ getCrawlModeTranslationKey(crawlModes.WEBSITE_SCRAPE_CONFIG_CRAWL_MODE_SINGLE) | translate }}
        </mat-option>
        <mat-option [value]="crawlModes.WEBSITE_SCRAPE_CONFIG_CRAWL_MODE_RECURSIVE">
          {{ getCrawlModeTranslationKey(crawlModes.WEBSITE_SCRAPE_CONFIG_CRAWL_MODE_RECURSIVE) | translate }}
        </mat-option>
      </mat-select>
      <glxy-hint *ngIf="form.get('crawlMode')?.value === crawlModes.WEBSITE_SCRAPE_CONFIG_CRAWL_MODE_RECURSIVE">
        {{ 'EDIT_KNOWLEDGE.WEBSITE_SCRAPE_CONFIG.FOLLOW_LINKS_HINT' | translate: { pageLimit: getPageLimit() } }}
      </glxy-hint>
    </glxy-form-field>
  </ng-container>
  <ng-container *ngTemplateOutlet="scrapedPages"></ng-container>
</ng-template>

<ng-template #scrapedPages>
  <div *ngIf="knowledgeSource" class="scraped-pages">
    <ng-container
      *ngIf="
        websiteScrapeConfig?.scrapeProgress === scrapeProgressStates.WEBSITE_SCRAPE_CONFIG_PROGRESS_DONE;
        else scrapeInProgress
      "
    >
      {{
        'EDIT_KNOWLEDGE.WEBSITE_SCRAPE_CONFIG.NUMBER_OF_PAGES_TRAINED'
          | translate: { trainedPagesCount: getTrainedPagesCount(), scrapedPagesCount: getScrapedPagesCount() }
      }}
    </ng-container>
    <ng-template #scrapeInProgress>
      <div>{{ getScrapeProgressTitle() | translate }}</div>
    </ng-template>
  </div>
</ng-template>
